import { StaticAnnouncementError, StaticAnnouncementErrorMini } from './static-announcement'

const PlaidCannotMonitorHeaderBanner = () => {
  return (
    <StaticAnnouncementError
      text={
        <>
          <b>We&apos;re unable to monitor your account for loan or lease repayments. </b>
          <br />
          To remain eligible, please email loan or lease repayment evidence to{' '}
          <a href="mailto:help@fasten.cc" className="hover:text-dGray-900 font-semibold text-brand-500">
            help@fasten.cc
          </a>
        </>
      }
    />
  )
}

const PlaidCannotMonitorPaymentsBanner = () => {
  return (
    <StaticAnnouncementErrorMini
      text={
        <>
          <b>We&apos;re unable to monitor your account for loan or lease repayments. </b>
          To remain eligible, please email loan or lease repayment evidence to{' '}
          <a href="mailto:help@fasten.cc" className="text-brand-500 font-[500] hover:text-dGray-900">
            help@fasten.cc
          </a>
        </>
      }
    />
  )
}

export { PlaidCannotMonitorHeaderBanner, PlaidCannotMonitorPaymentsBanner }
